/* global window, $ */

;(function() {
    'use strict';

    var VideoShare = function() {};

    VideoShare.prototype.getWindowHash = function() {
        return window.location.hash;
    };

    VideoShare.prototype.querySelector = function(query) {
        return document.querySelector(query).getAttribute('content');
    };

    VideoShare.prototype.getVideoId = function() {
        var videoIdPattern = /v\/[0-9]+/;
        var hashValue = this.getWindowHash();
        var result = hashValue.match(videoIdPattern);
        var matchedString = result && result[0];
        if (matchedString) {
            return matchedString.replace('v/', '');
        }
    };

    VideoShare.prototype.getFbAppId = function(SETTINGS) {
        var fbAppId = this.querySelector('meta[property="fb:app_id"]');
        return SETTINGS.FACEBOOK_APP_ID || fbAppId || '';
    };

    VideoShare.prototype.getShareUrl = function() {
        return window.location.origin + window.location.pathname + '#v/' + this.getVideoId();
    };

    VideoShare.prototype.init = function(window, GUILightbox, SETTINGS) {
        var videoId = this.getVideoId(window);
        if (videoId) {
            var fbAppId = this.getFbAppId(SETTINGS);
            var className = 'zueira';
            var $lightboxEl = $('<div>', {
                'class': className,
                'data-video-id': videoId,
                'data-link': this.getShareUrl(),
                'data-short-url': this.getShareUrl()
            });
            var $container = $('<div>', {'class': 'never-ends'});
            $container.append($lightboxEl);
            $container.appendTo('body');
            new GUILightbox($container, {fbAppId: fbAppId});
            $lightboxEl.trigger('click');
        }
    };

    if (typeof window !== 'undefined'){
        var isNotIframe = Boolean(window.top === window.self);
        if (isNotIframe) $(document).ready(function() {
            var videoShare = new VideoShare();
            videoShare.init(window, window.GUILightbox, window.SETTINGS);
        });
    }

    if (typeof module !== 'undefined') {
        module.exports = new VideoShare();
    }

})();
